import { motion } from 'framer-motion'
import { 
  CreditCard, 
  Users, 
  BarChart3, 
  MessageSquare, 
  Trophy, 
  Calendar,
  Shield,
  Zap
} from 'lucide-react'

const FeaturesSection = () => {
  const features = [
    {
      icon: CreditCard,
      title: 'Automatização de Pagamentos',
      description: 'Receba mensalidades automaticamente, reduza inadimplência e tenha controle total dos recebimentos.',
      color: 'text-green-600',
      bgColor: 'bg-green-100'
    },
    {
      icon: Users,
      title: 'Gestão Completa de Alunos',
      description: 'Cadastre, organize turmas e acompanhe o progresso de cada aluno de forma simples e eficiente.',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    },
    {
      icon: BarChart3,
      title: 'Relatórios e Indicadores',
      description: 'Acompanhe o desempenho da sua escola com dashboards completos e relatórios detalhados.',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100'
    },
    {
      icon: MessageSquare,
      title: 'Comunicação Integrada',
      description: 'Mantenha contato direto com alunos, pais e professores através do chat integrado.',
      color: 'text-orange-600',
      bgColor: 'bg-orange-100'
    },
    {
      icon: Trophy,
      title: 'Sistema de Conquistas',
      description: 'Motive seus alunos com troféus e níveis personalizados definidos pela sua escola.',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-100'
    },
    {
      icon: Calendar,
      title: 'Agenda Inteligente',
      description: 'Organize horários, aulas e eventos com uma agenda que se adapta às suas necessidades.',
      color: 'text-red-600',
      bgColor: 'bg-red-100'
    },
    {
      icon: Shield,
      title: 'Segurança Total',
      description: 'Seus dados protegidos com criptografia de ponta e conformidade com LGPD.',
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-100'
    },
    {
      icon: Zap,
      title: 'Implementação Rápida',
      description: 'Comece a usar em 7 dias com nossa equipe especializada e suporte completo.',
      color: 'text-pink-600',
      bgColor: 'bg-pink-100'
    }
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  }

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-dark-900 mb-4">
            Tudo que sua escola de natação precisa
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nossa plataforma oferece todas as ferramentas necessárias para 
            modernizar e otimizar a gestão da sua escola de natação.
          </p>
        </motion.div>

        {/* Features Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {features.map((feature, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="group"
            >
              <div className="card h-full hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1">
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-lg ${feature.bgColor} ${feature.color} mb-4`}>
                  <feature.icon className="h-6 w-6" />
                </div>
                
                <h3 className="text-lg font-semibold text-dark-900 mb-3">
                  {feature.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-center mt-16"
        >
          <p className="text-gray-600 mb-6">
            Quer conhecer todas as funcionalidades em detalhes?
          </p>
          <a href="/solucoes" className="btn-primary">
            Ver Todas as Funcionalidades
          </a>
        </motion.div>
      </div>
    </section>
  )
}

export default FeaturesSection
